import React from "react";
import { useLazyScans } from "../hooks";
import { Loading, Button } from "../../../components";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Table } from "./table";
import { Euro, ScanSearch, ShoppingCart } from "lucide-react";
import DatePicker from "react-datepicker";
import { formatDate } from "../../../helpers/date";

ChartJS.register(ArcElement, Tooltip, Legend);

interface IRecapProps {
  siteId: number;
}
export const Recap: React.FC<IRecapProps> = ({ siteId }) => {
  const [search, { data, loading, error }] = useLazyScans();
  let [startDate, setStartDate] = React.useState<Date | null>(null);
  let [endDate, setEndDate] = React.useState<Date | null>(null);

  React.useEffect(() => {
    search({
      variables: {
        limit: 10000,
        offset: 0,
        where: {
          siteId: siteId,
          start: "2024-09-10",
          end: "2024-09-16T20:00:00",
        },
      },
    });
  }, [siteId]);

  const renderDate = (date: string) => {
    return new Date(date).toLocaleDateString();
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <div className="w-full">
        <div className="card mb-2">
          <div className="grid gap-3 w-full items-center ">
            <div className="px-4 ">
              <div className="flex flex-wrap -mx-4 -mb-4 md:mb-0">
                <div className="w-full md:w-1/2 p-1">
                  <p className="label">Date Début</p>
                  <DatePicker
                    locale={"fr"}
                    selected={startDate}
                    onChange={(date) => {
                      setStartDate(date);
                    }}
                    className="input w-full"
                    wrapperClassName="w-full"
                    dateFormat="dd/MM/YYYY"
                  />
                </div>
                <div className="w-full md:w-1/2 p-1">
                  <p className="label">Date Fin</p>
                  <DatePicker
                    locale={"fr"}
                    selected={endDate}
                    onChange={(date) => {
                      setEndDate(date);
                    }}
                    className="input w-full"
                    wrapperClassName="w-full"
                    dateFormat="dd/MM/YYYY"
                  />
                </div>
              </div>
              <div className="flex justify-between  mt-4">
                <div></div>
                <Button
                  loading={false}
                  onClick={() => {
                    search({
                      variables: {
                        limit: 10000,
                        offset: 0,
                        where: {
                          siteId,
                          start: formatDate(startDate),
                          end: formatDate(endDate),
                        },
                      },
                    });
                  }}
                >
                  Rechercher
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-full sm:flex-none xl:mb-0 md:w-1/2 md:pr-1">
        <div className="card mb-2 relative flex flex-col min-w-0 break-words ">
          <div className="flex-auto p-1">
            <div className="flex flex-row -mx-3">
              <div className="flex-none w-2/3 max-w-full px-3">
                <div>
                  <p className="mb-0 font-sans font-semibold leading-normal text-sm">
                    Chiffre d'affaire
                  </p>
                  <h5 className="mb-0 font-bold">
                    {data?.scans?.results
                      ?.reduce((acc, scan) => acc + scan.ca, 0)
                      .toFixed(2)}{" "}
                    €
                  </h5>
                </div>
              </div>
              <div className="px-3 ml-auto">
                <div className="justify-center items-center flex w-10 h-10 rounded-sm bg-gradient-to-tl from-[#4E65FF] to-[#92EFFD] ">
                  <Euro size={24} color="white" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full max-w-full sm:flex-none xl:mb-0 md:w-1/2 md:pl-1 ">
        <div className="card mb-2 relative flex flex-col min-w-0 break-words ">
          <div className="flex-auto p-1">
            <div className="flex flex-row -mx-3">
              <div className="flex-none w-2/3 max-w-full px-3">
                <div>
                  <p className="mb-0 font-sans font-semibold leading-normal text-sm">
                    Nb Pcs Vendus
                  </p>
                  <h5 className="mb-0 font-bold">
                    {data?.scans?.results?.reduce(
                      (acc, scan) => acc + Math.abs(scan.quantityVariation),
                      0
                    )}{" "}
                    Pcs Vendus
                  </h5>
                </div>
              </div>
              <div className="px-3 ml-auto">
                <div className="justify-center items-center flex w-10 h-10 rounded-sm bg-gradient-to-tl from-[#4E65FF] to-[#92EFFD] ">
                  <ShoppingCart size={24} color="white" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full">
        <div className="card">
          {data?.scans?.results?.length ? (
            <Table
              iData={
                data?.scans?.results
                  ?.filter((scan) => scan.ca > 0)
                  .map((e) => ({
                    imgUrl: e.product?.imgUrl,
                    date: renderDate(e.createdAt),
                    name: e.product?.name?.toLocaleLowerCase(),
                    price: e.price + " €",
                    quantityVariation: Math.abs(e.quantityVariation),
                    ca: e.ca + " €",
                  })) || []
              }
            />
          ) : null}
        </div>
      </div>
    </>
  );
};

// <div className="flex mb-2">
//   <div className="w-full md:w-1/2 md:mr-2">
//     <div className="card">
//       <CardHeader title="CA par produit" />
//       <input
//         type="number"
//         value={limit}
//         onChange={(e) => setLimit(parseInt(e.target.value))}
//       />
//       <Doughnut
//         options={{
//           plugins: {
//             legend: {
//               display: true,
//               position: "bottom",
//             },
//             subtitle: {
//               display: true,
//               text: "CA par produit",
//             },

//             tooltip: {
//               callbacks: {
//                 label: function (tooltipItem) {
//                   let value = tooltipItem.raw; // Récupère la valeur brute
//                   return " " + value + " €";
//                 },
//                 title: function (tooltipItem) {
//                   return tooltipItem[0].label;
//                 },
//               },
//             },
//           },
//         }}
//         data={{
//           labels: data?.scans?.results
//             ?.filter((scan) => scan.ca)
//             .map((scan) => scan.product?.name)
//             .slice(0, limit),
//           datasets: [
//             {
//               data: data?.scans?.results
//                 ?.filter((scan) => scan.ca)
//                 .map((scan) => scan?.ca)
//                 .slice(0, limit),
//               backgroundColor: [
//                 "rgba(75, 192, 192, 0.6)",
//                 "rgba(153, 102, 255, 0.6)",
//                 "rgba(255, 159, 64, 0.6)",
//               ],
//               borderWidth: 1,
//             },
//           ],
//         }}
//       />
//     </div>
//   </div>

//   <div className="w-full md:w-1/2 md:ml-2 ">
//     <div className="card">
//       <CardHeader title="Vente par produit" />
//       <Doughnut
//         options={{
//           plugins: {
//             legend: {
//               display: true,
//               position: "bottom",
//             },
//             subtitle: {
//               display: true,
//               text: "CA par produit",
//             },

//             tooltip: {
//               callbacks: {
//                 label: function (tooltipItem) {
//                   let value = tooltipItem.raw; // Récupère la valeur brute
//                   return " " + value + " €";
//                 },
//                 title: function (tooltipItem) {
//                   return tooltipItem[0].label;
//                 },
//               },
//             },
//           },
//         }}
//         data={{
//           labels: data?.scans?.results
//             ?.filter((scan) => scan.quantityVariation < 0)
//             .map((scan) => scan.product?.name)
//             .slice(0, limit),
//           datasets: [
//             {
//               data: data?.scans?.results
//                 ?.filter((scan) => scan.quantityVariation < 0)
//                 .map((scan) => Math.abs(scan.quantityVariation))
//                 .slice(0, limit),
//               backgroundColor: [
//                 "rgba(75, 192, 192, 0.6)",
//                 "rgba(153, 102, 255, 0.6)",
//                 "rgba(255, 159, 64, 0.6)",
//               ],
//               borderWidth: 1,
//             },
//           ],
//         }}
//       />
//     </div>
//   </div>
// </div>;
